import script from "./editProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./editProfile.vue?vue&type=script&lang=ts&setup=true"

import "./editProfile.vue?vue&type=style&index=0&id=3878865e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3878865e"]])

export default __exports__